import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const RealHomes: Site = {
  id: 'realhomes',
  logo: 'svg/realhomes.svg',
  label: 'Real Homes',
  analyticsName: 'realhomes',
  hostname: 'realhomes.com',
  platform: 'progressive',
  selector: progressiveVanillaSelector,
};
